module.exports = __webpack_public_path__ + "static/media/PropertyEnrolment – Arabic.70081f03.jpg";